import styled from 'styled-components';

import {smallBold} from '~/shared/theme/typography';
import {FlexCenter} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';

export const Title = styled.h2`
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: 700;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-bottom: 16px;
`;

export const ErrorText = styled.span`
  ${smallBold}
  display: block;
  color: ${({theme}) => theme.colors.error};
`;

export const LoaderContainer = styled(FlexCenter)`
  width: 100%;
  min-height: 330px;
`;

export const Separator = styled.div`
  width: 100vw;
  height: 8px;
  background-color: ${({theme}) => theme.colors.actionSecondary};
  position: absolute;
  bottom: -12px;
  ${flipOnLTR`
    left: -16px;  
  `}
`;
